import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import { isBlackWeek } from "./../../config";
import NewsletterForm from "@/components/NewsletterForm";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

const Header = () => {
  const { t } = useTranslation("common");

  const showBlackWeekBanner = isBlackWeek();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const { pathname, locale } = useRouter();

  const excludedPaths = ["/polaroid-kamera-mieten", "/sofortbildkamera-mieten"];
  const isExcluded = excludedPaths.includes(pathname);

  const [showNewsletterBanner, setShowNewsletterBanner] = useState(() => {
    if (typeof window === "undefined") {
      // Server-Side Render: Zeige Banner nur, wenn NICHT ausgeschlossen
      return !isExcluded && locale === "de";
    }

    // Client-Side
    const isNewsletterFilledOut = localStorage.getItem("NewsletterFilledOut");
    return !isExcluded && !isNewsletterFilledOut && locale === "de";
  });

  useEffect(() => {
    // Optionales Update, falls localStorage sich ändert
    const isNewsletterFilledOut = localStorage.getItem("NewsletterFilledOut");
    if (isExcluded || isNewsletterFilledOut || locale !== "de") {
      setShowNewsletterBanner(false);
    }
  }, [pathname, locale]);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleNewsletterSubmit = () => {
    // Nach erfolgreicher Anmeldung LocalStorage setzen und Banner ausblenden
    localStorage.setItem("NewsletterFilledOut", "true");
    setShowNewsletterBanner(false);
    setIsModalOpen(false);
  };

  return (
    <>
      <header className="bg-white py-2 shadow-sm">
        <div className="flex max-w-7xl mx-auto px-4 lg:px-8 justify-between items-center gap-x-5 lg:gap-x-10">
          <Link href="/">
            <Image
              src={
                locale === "de"
                  ? "/logo/fotoboxguru-logo.svg"
                  : "/logo/boothscanner-logo.svg"
              }
              width={224}
              height={57}
              alt={locale === "de" ? "FotoboxGuru Logo" : "BoothScanner Logo"}
              className={locale === "de" ? "w-42 lg:w-56" : "w-42 lg:w-64"}
            />
          </Link>
        </div>
      </header>

      {showBlackWeekBanner && (
        <div className="bg-black flex items-center justify-center text-white p-5 lg:p-2 text-center gap-2 flex-col lg:flex-row">
          <div className="p-[2px] rounded-md bg-gradient-to-r from-[#FF487F] via-[#E73D4B] to-[#F7603C] ">
            <div className="bg-black rounded-md px-2 py-1 text-center font-bold">
              BlackWeek
            </div>
          </div>
          <div className="text-center">
            <span className="font-bold">50% Rabatt</span> auf den Mietpreis
            einer Polaroid-Sofortbildkamera! Code:{" "}
            <span className="font-bold">BLACKFRIDAY</span>
          </div>
          {showLink && (
            <a
              className="px-3 py-1 rounded-md bg-gradient-to-r from-[#FF487F] via-[#E73D4B] to-[#F7603C] mr-2"
              href="/polaroid-kamera-mieten?ref=index-blackweek-banner"
            >
              Zu den Kameras
            </a>
          )}
        </div>
      )}

      {showNewsletterBanner && (
        <div className="bg-black flex items-center justify-center text-white p-5 lg:p-2 text-center gap-2 flex-col lg:flex-row">
          <div className="p-[2px] rounded-md bg-gradient-to-r from-[#FF487F] via-[#E73D4B] to-[#F7603C]">
            <div className="bg-black rounded-md px-2 py-1 text-center font-bold">
              Fotobox Gutscheine
            </div>
          </div>
          <div className="text-center">
            Erhalte{" "}
            <span className="font-bold">exklusive Fotobox Gutscheine</span>{" "}
            verschiedener Fotobox-Anbieter:
          </div>
          <a
            className="px-3 py-1 rounded-md bg-gradient-to-r from-[#FF487F] via-[#E73D4B] to-[#F7603C] mr-2 cursor-pointer"
            onClick={openModal}
          >
            Jetzt anmelden
          </a>
        </div>
      )}

      {/* Modal für die Newsletter-Anmeldung */}
      {isModalOpen && (
        <NewsletterForm
          onClose={closeModal}
          onSubmit={handleNewsletterSubmit}
        />
      )}
    </>
  );
};

export default Header;
